import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0094d2a8&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=0094d2a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094d2a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0094d2a8')) {
      api.createRecord('0094d2a8', component.options)
    } else {
      api.reload('0094d2a8', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=0094d2a8&scoped=true", function () {
      api.rerender('0094d2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/views/Main.vue"
export default component.exports